import { useMemo } from 'react';
import { Swords } from 'lucide-react';
import Card from '../ui/Card';

const HeadToHeadCard = ({ selectedPlayer, comparePlayer, filteredMatches }) => {
  const { commonMatches, p1Wins, p2Wins } = useMemo(() => {
    if (!selectedPlayer || !comparePlayer || !filteredMatches) {
      return { commonMatches: [], p1Wins: 0, p2Wins: 0 };
    }

    const commonMatches = filteredMatches.filter(m => {
      const p1In =
        m.winners.includes(selectedPlayer.id) ||
        m.losers.includes(selectedPlayer.id);
      const p2In =
        m.winners.includes(comparePlayer.id) ||
        m.losers.includes(comparePlayer.id);

      // Must be opponents
      const opponents =
        (m.winners.includes(selectedPlayer.id) &&
          m.losers.includes(comparePlayer.id)) ||
        (m.winners.includes(comparePlayer.id) &&
          m.losers.includes(selectedPlayer.id));

      return p1In && p2In && opponents;
    });

    const p1Wins = commonMatches.filter(m =>
      m.winners.includes(selectedPlayer.id)
    ).length;

    const p2Wins = commonMatches.length - p1Wins;

    return { commonMatches, p1Wins, p2Wins };
  }, [selectedPlayer, comparePlayer, filteredMatches]);

  return (
    <Card className="p-6 bg-zinc-900 text-white border-zinc-900">
      <div className="flex items-center gap-2 mb-4 text-zinc-400">
        <Swords className="w-4 h-4" />
        <h3 className="text-xs font-bold uppercase tracking-widest">
          Head to Head
        </h3>
      </div>
      <div className="flex justify-between items-end">
        <div className="text-center">
          <div className="text-2xl font-bold">{p1Wins}</div>
          <div className="text-[10px] text-zinc-500 uppercase">Wins</div>
        </div>
        <div className="text-xs font-bold text-zinc-500 mb-2">VS</div>
        <div className="text-center">
          <div className="text-2xl font-bold">{p2Wins}</div>
          <div className="text-[10px] text-zinc-500 uppercase">Wins</div>
        </div>
      </div>
      <div className="mt-4 text-xs text-zinc-500 text-center">
        {commonMatches.length} total games played against each other.
      </div>
    </Card>
  );
};

export default HeadToHeadCard;
